export default __webpack_public_path__ + "static/media/Button_Disclosure_Back.dc6f2dc1.svg";